import React, { useEffect, useState } from 'react'
import { Button, CircularProgress, Box } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'
import { getdoc } from '../api'

export default function GetDocument({
  dsTokenArquivo,
  base64,
  assinado = false,
}) {
  const [loading, setLoading] = useState(true)
  const [fileUrl, setFileUrl] = useState(null)
  const [fileType, setFileType] = useState(null)
  const [fileName, setFileName] = useState('arquivo')

  useEffect(() => {
    loadDocument()
    return () => {
      if (fileUrl) URL.revokeObjectURL(fileUrl)
    }
    // eslint-disable-next-line
  }, [dsTokenArquivo, base64]);

  const loadDocument = async () => {
    setLoading(true)

    try {
      const response = await getdoc(dsTokenArquivo, base64, assinado)

      if (base64) {
        const cleanB64 = response.base64.replace(/^data:[^;]+;base64,/, '')
        const blob = base64ToBlob(cleanB64, response.fileType)
        const url = URL.createObjectURL(blob)

        setFileUrl(url)
        setFileType(response.fileType)
        setFileName(response.fileName)
      } else {
        if (typeof response.blob !== 'function') {
          console.error('Resposta inválida para blob()')
          setLoading(false)
          return
        }

        const blob = await response.blob()
        const url = URL.createObjectURL(blob)
        const contentType = blob.type || 'application/octet-stream'
        setFileType(contentType)

        const disposition = response.headers.get('Content-Disposition')
        let filename = 'arquivo.bin'

        const parsed = parseContentDisposition(disposition)
        if (parsed) filename = parsed

        setFileName(filename)
        setFileUrl(url)
      }
    } catch (err) {
      console.error('Erro ao carregar documento:', err)
    }

    setLoading(false)
  }

  function parseContentDisposition(disposition) {
    if (!disposition) return null

    const filenameStarMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i)
    if (filenameStarMatch && filenameStarMatch[1]) {
      try {
        const encoded = filenameStarMatch[1].trim()
        return decodeURIComponent(encoded.replace(/\+/g, '%20'))
      } catch (e) {
        return filenameStarMatch[1].replace(/['"]/g, '')
      }
    }

    const filenameQuotedMatch = disposition.match(/filename="([^"]+)"/i)
    if (filenameQuotedMatch && filenameQuotedMatch[1]) {
      return filenameQuotedMatch[1]
    }

    const filenameMatch = disposition.match(/filename=([^;]+)/i)
    if (filenameMatch && filenameMatch[1]) {
      return filenameMatch[1].replace(/["']/g, '').trim()
    }

    return null
  }

  const base64ToBlob = (b64, type) => {
    const byteChars = atob(b64)
    const byteArrays = []

    for (let offset = 0; offset < byteChars.length; offset += 512) {
      const slice = byteChars.slice(offset, offset + 512)
      const byteNumbers = new Array(slice.length)

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      byteArrays.push(new Uint8Array(byteNumbers))
    }

    return new Blob(byteArrays, { type })
  }

  const isViewable = () => {
    if (fileType?.length) return true

    return false
  }

  const renderViewer = () => {
    if (!fileUrl || !fileType) return null

    if (fileType.startsWith('image/')) {
      return <img src={fileUrl} alt="" style={{ maxWidth: '100%' }} />
    }
    if (fileType?.startsWith('application/pdf')) {
      return (
        <iframe
          src={fileUrl}
          title="PDF Viewer"
          style={{
            width: '100%',
            height: '80vh',
            border: '1px solid #ccc',
          }}
        />
      )
    }

    if (fileType.startsWith('text/') && fileType !== 'text/csv') {
      return (
        <iframe
          src={fileUrl}
          title="Text Viewer"
          style={{
            width: '100%',
            height: '80vh',
            border: '1px solid #ccc',
          }}
        />
      )
    }
  }

  const download = () => {
    if (!fileUrl) return
    const a = document.createElement('a')
    a.href = fileUrl
    a.download = fileName
    a.click()
  }

  return (
    <Box p={1}>
      {loading ? (
        <Box
          display="flex"
          justifyContent={renderViewer() == null ? 'center' : 'flex-end'}
          alignItems="center"
          paddingBottom={2}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          {isViewable() && (
            <Box
              display="flex"
              justifyContent={renderViewer() == null ? 'center' : 'flex-end'}
              alignItems="center"
              paddingBottom={2}
            >
              <Button
                variant="outlined"
                size="small"
                style={{ borderRadius: 20 }}
                startIcon={<DownloadIcon />}
                onClick={download}
                sx={{
                  textTransform: 'none',
                }}
              >
                Baixar {fileName}
              </Button>
            </Box>
          )}

          {renderViewer()}
        </>
      )}
    </Box>
  )
}
